export const handleGoBackSection = ({
  setActiveIndex,
  activeIndex,
  setDataError,
  setError,
  setSectionError,
  sections,
}) => {
  if (activeIndex.propertyIndex > 0) {
    setActiveIndex({
      sectionIndex: activeIndex.sectionIndex,
      propertyIndex: activeIndex.propertyIndex - 1,
    });
  } else if (sections.length > 0) {
    setActiveIndex({
      sectionIndex: activeIndex.sectionIndex - 1,
      propertyIndex: 0,
    });
  }
  setDataError({});
  setError('');
  setSectionError('');
};
